import {
	DrawerBody,
	Stack,
	Box,
	Flex,
	Image,
	Text,
	Spacer,
	Button,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	ModalHeader,
	ModalCloseButton,
	useDisclosure,
	useToast,
	Progress,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { Raider } from "../../../../types/raider";
import { timeConverter } from "../../../../util/helpers";
import {
	endQuest,
	expRewardAmount,
	getEarned,
	getQuestDuration,
	nextReward,
	rewardTime,
} from "../../../../util/web3/interactQuests";

interface QuestProps {
	raider: Raider;
	questName: string;
	questIcon: string;
	rewardName: string;
	questString: string;
}

export default function OnQuest(props: QuestProps) {
	const { raider, questName, questIcon, rewardName, questString } = props;
	const [questDuration, setQuestDuration] = useState<number>();
	const [nextRewardTime, setNextRewardTime] = useState<number>();
	const [baseRewardTime, setBaseRewardTime] = useState<number>();
	const [earned, setEarned] = useState<number>();
	const [expReward, setExpReward] = useState<number>();

	const endQuestModal = useDisclosure();

	const toast = useToast();

	useEffect(() => {
		const fetchData = async () => {
			const id = parseInt(raider.id);
			setQuestDuration(await getQuestDuration(id, questString));
			setEarned(await getEarned(id, questString));
			setNextRewardTime(await nextReward(id, questString));
			setBaseRewardTime(await rewardTime(id, questString));
			setExpReward(await expRewardAmount(questString));
		};

		fetchData();
	}, []);

	return (
		<DrawerBody>
			<Stack py="2" px="2">
				<Box background="#4a556878" borderRadius="md" px={4} py={8}>
					<Flex mb="20px" justifyContent="left" alignItems="center">
						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/basicQuest.png"
							width="40px"
							height="40px"
							alt="quest"
						/>
						<Text textStyle="questStatusHeader">{questName}</Text>
					</Flex>
					<Flex alignItems="center">
						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/clock.png"
							alt="clock"
							width="25px"
							height="25px"
							mr="5px"
						/>
						<Text mr="5px">Total quest time:</Text>
						{questDuration && (
							<Text textStyle="timeBlock">{timeConverter(questDuration)}</Text>
						)}
						<Spacer />
						<Image
							src={questIcon}
							width="25px"
							height="25px"
							alt={rewardName}
							mr="5px"
						/>
						<Text mr="5px">+1 {rewardName} in: </Text>
						{nextRewardTime != undefined && (
							<Text textStyle="timeBlock">{timeConverter(nextRewardTime)}</Text>
						)}
					</Flex>
					{nextRewardTime && baseRewardTime && (
						<Progress
							value={(1 - nextRewardTime / baseRewardTime) * 100}
							colorScheme="cyan"
							mt="16px !important"
						/>
					)}
					<Flex mt="16px !important">
						<Text mr="15px">Earned: </Text>
						<Image
							src={questIcon}
							width="25px"
							height="25px"
							alt={rewardName}
							mr="2px"
						/>
						<Text mr="15px">
							+{earned} {rewardName}
						</Text>

						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/herbalism.png"
							width="25px"
							height="25px"
							alt={rewardName}
							mr="2px"
						/>
						{earned != undefined && <Text>+{earned * expReward!} Herbalism XP</Text>}
					</Flex>
				</Box>

				<Button mt="30px !important" onClick={() => endQuestModal.onOpen()}>
					End Quest & Return Home
				</Button>
			</Stack>
			<Modal isOpen={endQuestModal.isOpen} onClose={endQuestModal.onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>End {questName}?</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Text mb={5}>
							Your Raider will pack up their gear and start returning home. It
							will take 1/4 of the quest duration to return home, unless you
							have a Mount or other speed boost.
						</Text>
						<Text>
							Once they&apos;re home you&apos;ll be able to retrieve their
							rewards!
						</Text>
					</ModalBody>

					<ModalFooter>
						<Button
							colorScheme="red"
							variant="ghost"
							mr={3}
							onClick={endQuestModal.onClose}
						>
							Nevermind
						</Button>
						{questString && (
							<Button
								colorScheme="green"
								onClick={() => {
									endQuest(parseInt(raider.id), questString, toast);
									endQuestModal.onClose();
								}}
							>
								End Quest
							</Button>
						)}
					</ModalFooter>
				</ModalContent>
			</Modal>
		</DrawerBody>
	);
}
